<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isGarbageTypeDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GarbageKnowledgeEdit',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USERDELIVERYGARBAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/garbageType/garbageTypeUpdate',
      formAddUrl: '/modules/garbageType/garbageTypeAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        className: 'wt-section-long-content',
        elements: [
          { name: '垃圾名称',
            key: 'name',
            type: 'text',
            disabled: false,
            className: 'wt-col-6',
            required: true,
            rules: [
              { min: 1, max: 20, message: '垃圾名称长度不能超过20', trigger: 'blur' }
            ] },
          { name: '垃圾图片', key: 'coverPathList', type: 'image', disabled: false, required: true, limit: 1, markText: '上传图片尺寸686x300px' },
          { name: '垃圾介绍', key: 'content', type: 'editor', disabled: false }]
      },
      compareData: {}
    }
  },
  created() {
    if (this.componentType === 'add') {
      this.$store.dispatch('appendBreadcrumb', { meta: { title: '新增' }})
      // this.detailFormData.content = ''
    } else {
      this.detailFormData.coverPathList = [{ fileUrl: this.detailFormData.coverPath }]
      if (!this.detailFormData.content || this.detailFormData.content.length === 0) {
        this.detailFormData.content = ''
      }
      this.$store.dispatch('appendBreadcrumb', { meta: { title: '编辑' }})
      this.compareData = JSON.parse(JSON.stringify(this.detailFormData))
    }
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$store.dispatch('removeBreadcrumb')
        this.$store.dispatch('setGarbageTypeDetailData', this.compareData)
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddUserDeliveryGarbageDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateUserDeliveryGarbageDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddUserDeliveryGarbageDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      delete sendData.coverPathList
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '新增垃圾知识成功', type: 'success' })
        this.$store.dispatch('removeBreadcrumb')
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    requestUpdateUserDeliveryGarbageDetail() {
      const that = this
      const sendData = JSON.parse(JSON.stringify(this.detailFormData))
      sendData.coverPath = this.detailFormData.coverPathList[0].fileUrl
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: sendData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '修改垃圾知识成功', type: 'success' })
        this.$store.dispatch('setGarbageTypeDetailData', sendData)
        this.$store.dispatch('removeBreadcrumb')
        that.$emit('on-dialog-action', 'refresh')
        that.$emit('on-dialog-action', 'close')
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isGarbageTypeDetailLoading: state => state.garbageType.isGarbageTypeDetailLoading,
      detailFormData: state => state.garbageType.garbageTypeDetailData
    })
  }
}
</script>

<style scoped>

</style>
